import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import LinearProgress from '@mui/material/LinearProgress';
import SnackbarContext from "../../../Context/SnackbarContext";
import {
    editProductServiceCategory,
    getProductServiceCategoryList
} from "../../../Services/Product/ProductServiceCategoryService";
import ProductServiceCategoryForm from "../../../Components/Forms/Pages/Product/ProductServiceCategoryForm";


const formRules = {
    'name': {required: true}, 'publicName': {required: true}
}

const EditProductServiceCategory = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: props.data && props.data.length > 0 ? props.data[0] : undefined
    });
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [productServiceCategories, setProductServiceCategories] = useState(0);


    useEffect(() => {
        setDrawerTitle(strings.pages.product.productServiceCategory.editProductServiceCategory.pageTitle);
    });

    useEffect(()=>{
        fetchParent();
    },[])

    const fetchParent = (term = "") => {
        getProductServiceCategoryList({term}).then((response) => {
            if (!response || !response.ok) {
                return;
            }
            setProductServiceCategories(response.data.result);
        });
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        editProductServiceCategory(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorEditing, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.editingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <ProductServiceCategoryForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                onParentChangeFilter={fetchParent}
                parent={productServiceCategories}
                errors={errors} data={data} form={form} control={control}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default EditProductServiceCategory;